import {Injectable} from "@angular/core";

import {environment} from "@environment";
import {LiveResult, PagedFilter, Race} from "@model";
import {LiveResultFilter} from "../model/live-result-filter";
import {LiveResultsService} from "./live-results.service";
import {BehaviorSubject} from "rxjs";

@Injectable({providedIn: 'root'})
export class LiveControlService {

  public static readonly TIMEOUT_30 = 30000;
  public static readonly TIMEOUT_4 = 4000;

  private intervalId: NodeJS.Timeout | null = null;
  private _liveResult: BehaviorSubject<LiveResult | undefined | null> = new BehaviorSubject<LiveResult | undefined | null>(null);

  constructor(private liveResultsService: LiveResultsService) {
    this.intervalId = null;
  }


  get liveResults(): BehaviorSubject<LiveResult | null | undefined> {
    return this._liveResult;
  }


  clearResults() {
    this.liveResults.next(undefined);
  }


  startFetchingResults(race: Race | undefined, filter: PagedFilter<LiveResultFilter>) {
    this.clearAll();
    if (race?.raceStart && race?.raceEnd) {
      const raceStart = new Date(race.raceStart).getTime();
      const raceEnd = new Date(race.raceEnd).getTime();
      const now = new Date().getTime();

      //Live race
      if (now >= raceStart && now <= raceEnd) {
        this.fetchResults(filter);

        this.intervalId = setInterval(() => {
          this.fetchResults(filter);
        }, LiveControlService.TIMEOUT_4);

        this.finalize(raceEnd + LiveControlService.TIMEOUT_30 - now, filter)
      }
      // Race starts later today
      else if (now + environment.dayInSeconds > raceStart) {
        const timeUntilRaceStart = raceStart - now;

        setTimeout(() => {
          this.intervalId = setInterval(() => {
            this.fetchResults(filter);
          }, LiveControlService.TIMEOUT_4); // 4 seconds interval
        }, timeUntilRaceStart);
        this.finalize(raceEnd + LiveControlService.TIMEOUT_30 - now, filter)
      }
    }
  }

  fetchResults(pagedFilter: PagedFilter<LiveResultFilter>) {
    this.liveResultsService.fetchLiveResults(pagedFilter, true).subscribe(results => {
      this.liveResults.next(results);
    })
  }


  stopFetching() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }

  finalize(timeAfterRaceEnd: number, filter: PagedFilter<LiveResultFilter>) {
    setTimeout(() => {
      this.stopFetching();
      filter.filter.finalize()
      this.fetchResults(filter);
    }, timeAfterRaceEnd);
  }

  clearAll(): void {
    this.stopFetching();
    this.clearResults();
  }

  ngOnDestroy(): void {
    this.clearAll();
  }
}

